import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { CoinBalance } from '@/types/coins'

import { MOCK_COIN_BALANCE } from './mocks'

export const apiGetCoinBalance = async (): Promise<CoinBalance> => {
  if (IS_MOCK) {
    await mockDelay()
    return MOCK_COIN_BALANCE
  }
  return await api.get<CoinBalance>('/coins/balance')
}
